import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import * as globals from '../globals';

@Injectable()
export class UtilsService {
    progress$: any;
    progress: any;
    progressObserver: any;
    private bucketname = globals.BUCKETNAME;

  constructor () {

  }


  determineModelType(filename: string) {
    if (!filename) {
      return 0;
    }

    const fileparts = filename.split('.');
    if (fileparts.length < 2) { return 0; }

    let ext = fileparts.pop();

    // This is to account for part filenames that have multiple extensions
    // e.g. *.prt.*
    /*let preext = '';
    if (fileparts.length > 1) {
      preext = fileparts.pop();
      preext = preext.toLowerCase();
    }*/

    ext = ext.toLowerCase();

    if (ext === '3dxml') { return 1; }
    if (ext === 'ipt') { return 2; }
    if (ext === 'catpart') { return 3; }
    if (ext === 'igs' || ext === 'iges') { return 4; }
    if (ext === 'jt') { return 5; }
    if (ext === 'x_t' || ext === 'x_b') { return 6; }
    if (ext === 'prc') { return 7; }
    if (ext === 'prt') { return 8; }
    if (ext === '3dm') { return 9; }
    if (ext === 'sat' || ext === 'sab') { return 10; }
    // if (ext === 'prt') { return 11; }
    if (ext === 'par') { return 12; }
    if (ext === 'sldprt') { return 13; }
    if (ext === 'stp' || ext === 'step') { return 14; }
    if (ext === 'stl') { return 15; }
    if (ext === 'u3d') { return 16; }
    if (ext === 'wrl') { return 17; }
    if (ext === 'dxf') { return 18; }
    if (ext === 'dwg') { return 19; }
    if (ext === 'pdf' || ext === "PDF") { return 25; }

    return 0;
  }

  getModelName(type: number) {

    switch (type) {
      case 1: return '3DVIA';
      case 2: return 'Inventor';
      case 3: return 'CATIA';
      case 4: return 'IGES';
      case 5: return 'JT';
      case 6: return 'Parasolid XT';
      case 7: return 'PRC';
      case 8: return 'NX or ProE';
      case 9: return 'Rhino';
      case 10: return 'ACIS';
      case 11: return 'NX/PTC';
      case 12: return 'Solid Edge';
      case 13: return 'Solidworks';
      case 14: return 'STEP';
      case 15: return 'Stereo Lithography';
      case 16: return 'Universal 3D';
      case 17: return 'VRML';
      case 18: return 'DXF';
      case 19: return 'DWG';
      default: return 'Unknown';
    }
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/utils.service.ts